import React from 'react';

const JournalNamesHeader = () => {
    return (
        <div>
            <h1>Journal Names</h1>
        </div>
    );
};

export default JournalNamesHeader;
